/**
 * AtomIcon - Custom AI Assistant Icon Component
 *
 * Renders the atom.png image as an icon with consistent styling.
 * Supports MUI sx prop for sizing and styling.
 */

import React from 'react';
import { Box } from '@mui/material';

const AtomIcon = ({ sx = {}, ...props }) => {
  // Extract fontSize from sx prop (default to 24px like MUI icons)
  const fontSize = sx.fontSize || 24;

  // Convert fontSize to pixels if it's a number
  const size = typeof fontSize === 'number' ? fontSize : fontSize;

  return (
    <Box
      component="img"
      src="/img/atom.svg"
      alt="AI"
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        ...sx,
        // Override width/height from sx if provided
        ...(sx.fontSize && { width: size, height: size }),
      }}
      {...props}
    />
  );
};

export default AtomIcon;
